import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { routerHistory } from './redux/redux-config';
//import reportWebVitals from './reportWebVitals';


const root = document.getElementById('root');
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  root
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/serviceworker.js').catch((err) => {
      console.error('Service worker registration failed:', err);
    });
  });

  // Handle navigation requests from the service worker (e.g. push notification click).
  // routerHistory.push performs a soft React Router navigation that preserves Redux auth state,
  // avoiding the hard reload that client.navigate() would cause.
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'SW_NAVIGATE') {
      routerHistory.push(event.data.url);
    }
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
